import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { AdPartner, AdPartnerBlueprint } from '../../../../main/types/adPartnerTypes';
import { AdPartnerService } from '../../../services/AdPartner.service';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetAdPartnersRequestActionPayload, GetAdPartnersResponseActionPayload } from '../AdPartner.types';

const GetAdPartners = new ReduxAsyncAction<
  'AD_PARTNER_GET_PARTNER',
  GetAdPartnersRequestActionPayload,
  GetAdPartnersResponseActionPayload
>('AD_PARTNER_GET_PARTNER');

GetAdPartners.registerRequest(async ({ partner }) => {
  const [appConfigsPayload, blueprintsPayload] = await Promise.all([
    dash_api.get<Record<string, AdPartner>>(`/v1/ad-networks/app`),
    dash_api.get<AdPartnerBlueprint[]>(`/v1/ad-networks/global`),
  ]);

  const mergedConfigs = AdPartnerService.mergeAppsWithBlueprints(appConfigsPayload.data, blueprintsPayload.data);

  return {
    partners: mergedConfigs,
    selected: partner,
    hasPartnersLoaded: true,
  };
});

export const GET_PARTNERS = GetAdPartners.actionNamespaceConstants;

export const getAdPartners = GetAdPartners.request;

export type GetAdPartnersResponseAction = Action<typeof GET_PARTNERS.response> & {
  data: GetAdPartnersResponseActionPayload;
};
